import React from 'react';
import DefaultQuestionnaireModal from './DefaultQuestionnaireModal';

interface SetDefaultModalProps {
  isOpen: boolean;
  questionnaireName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const SetDefaultModal: React.FC<SetDefaultModalProps> = ({
  isOpen,
  questionnaireName,
  onConfirm,
  onCancel,
}) => {
  return (
    <DefaultQuestionnaireModal
      isOpen={isOpen}
      position="top"
      onClose={onCancel}
      footer={
        <div className="dq-modal-footer">
          <button className="dq-btn dq-btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="dq-btn dq-btn--primary" onClick={onConfirm}>
            Set as Default
          </button>
        </div>
      }
    >
      <h3 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '1rem', color: '#181C32' }}>Set as Default Questionnaire</h3>
      <p>
        Going forward, this questionnaire will be automatically applied <br />to all new job postings. You can update this setting at any time.
      </p>
    </DefaultQuestionnaireModal>
  );
};

export default SetDefaultModal;
